import { ControlsToggleExtraContent } from "@jelly/lesson";
import config from "appConfig";

const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "secondary",
      text: "1",
      url: `${config.ASSETS_URL}/02/21/principle/front-0.wav`,
      icon: "cis-volume-high",
      shape: "round",
      styles: {
        marginTop: "20px",
      },
    },
  },
  {
    type: "audioButton",
    options: {
      theme: "secondary",
      text: "2",
      url: `${config.ASSETS_URL}/02/21/principle/back-0.wav`,
      icon: "cis-volume-high",
      shape: "round",
      styles: {
        marginTop: "20px",
      },
    },
  },
];

export default extraContent;
